<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div :class="`${$style.templatePage} ${$style.hiddenTitle}`">
      <header>
        <div @click="closePage">
          <i class="iconfont yw-xiangzuo"></i>
        </div>
        <span>{{ pageTitle }}</span>
      </header>
      <div :class="$style.templateContent">
        <img :class="$style.image" :src="imageUrl.background" />
        <img :class="$style.btn" :src="imageUrl.button" @click="onClick" />
      </div>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import {
  onGoBack,
  setPageTitle,
  getUserInfo,
  toLogin,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import { getCookie } from "@/libs/utils";
import { CDN_URL_1 } from "@/config";
import { burnPoint } from "@/apis/heziShare";

const IMAGE_URL = {
  background: `${CDN_URL_1}/box_rebate/rebateBg.jpg`,
  button: `${CDN_URL_1}/box_rebate/rebateBtn1.png`,
};
export default {
  name: "",
  components: { PullRefresh },
  data() {
    return {
      hiddenTitle: true,
      isLoading: false,
      pageTitle: "玩心手游新春福利",
      imageUrl: IMAGE_URL,
      cookie: null,
      isClicked: false,
      uid:null
    };
  },
  created() {
    // 页面初始化
    inithandler();
    this.initPageData();
  },
  activated() {},
  methods: {
    // 获取cookie、缓存等携带的用户信息数据
    initPageData() {
      setPageTitle(this.pageTitle);
      
      // 获取登录态
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        if (pageCookie.userId) {
          this.uid = pageCookie.userId;
        }
        this.cookie = pageCookie;
      }
      
      // 获取token
      this.getAppToken();
    },
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.setButtonStatus();
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.uid) {
            this.uid = Info.uid;
          }
          if (Info.token) {
            localStorage.setItem("token", Info.token);
            this.setButtonStatus();
          } else {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        });
      }
    },

    setButtonStatus() {
      this.eventTrack({
        event: "pic_activity_page",
        event_field: JSON.stringify({ activity_name: this.pageTitle, activity_id:'null' }),
      });
      const status = localStorage.getItem(`${this.uid}_rebate`);
      if (status) {
        this.isClicked = true;
        this.imageUrl = {
          ...this.imageUrl,
          button: `${CDN_URL_1}/box_rebate/rebateBtn2.png`,
        };
      }
    },
    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      burnPoint({
        ...this.cookie,
        userId: this.uid,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 关闭页面
    closePage() {
      onGoBack();
    },

    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onClick() {
      if (this.isClicked) {
        return;
      }
      if (!this.uid) {
        toLogin("/loginKey/LoginByKeyPhoneActivity");
        return;
      }
      this.$toast("已参与活动");
      localStorage.setItem(`${this.uid}_rebate`, 1);
      this.imageUrl = {
        ...this.imageUrl,
        button: `${CDN_URL_1}/box_rebate/rebateBtn2.png`,
      };
      this.eventTrack({
        event: "pic_activity_gift_icon",
        event_field: JSON.stringify({ activity_name: this.pageTitle, activity_id:'null' }),
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.templatePage {
  width: 100%;
  height: 100%;
  max-width: 375px;
  margin: auto;
  padding-top: 50px;
  overflow: auto;
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .templateContent {
    width: 100%;
    height: auto;
    .image {
      width: 100%;
    }

    .btn {
      width: 95%;
      position: fixed;
      bottom: 20px;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
}
</style>
